import { ICalibrationModel } from '../model';

export default (self: ICalibrationModel) => {
  return {
    get calibrationStatusFilterTags() {
      // self.status = getDeviceStatus: 'not_run' (no parameters) | 'fail' (any parameter calibrated:false) | 'ok'
      return [self.status];
    },
    get calibrationSensorFilterTags() {
      // the sensor (parameter) names this device has a calibration record for, e.g. Temperature/RH/VOC
      return (self.measurements ?? []).map((measurement) => measurement.name).filter(Boolean);
    },
    get filterTags() {
      return [...self.calibrationStatusFilterTags, ...self.calibrationSensorFilterTags].map((tag) => tag.toLowerCase());
    },
    get searchString() {
      const { serial, statusText } = self;
      return [serial, statusText, ...self.calibrationSensorFilterTags].join(' ').toLowerCase();
    }
  };
};
